<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }, { name: 'アカウント管理', pathName: 'settingAccounts' }]"
        :title="'アカウント'+ formTypeLabel"
        data-test="title"
      />
      <div class="grid-x align-justify">
        <div class="medium-6 cell">
          <p>下記の項目を入力してください。</p>
        </div>
      </div>
      <form-item
        v-model="staffName"
        data-test="name-invalid"
      >
        <template slot="label">
          <span class="medium-3 cell pega-form-label">氏名&nbsp;<small>(50文字以内)</small></span>
        </template>
      </form-item>
      <form-item
        v-model="tel"
        data-test="tel-invalid"
      >
        <template slot="label">
          <span class="medium-3 cell pega-form-label">TEL&nbsp;<small>(任意：50文字以内)</small></span>
        </template>
      </form-item>
      <form-item
        v-model="email"
        data-test="email-invalid"
      >
        <template slot="label">
          <span class="medium-3 cell pega-form-label">メールアドレス</span>
        </template>
      </form-item>
      <form-item
        :value="loginIdLabel"
        label="ログインID"
        tag="label"
        type=""
      />
      <form-item-number
        v-model="authentication"
        :class-name="isLengthValidationAuthentication ? 'is-invalid-input certification-number-length': 'certification-number-length'"
        :errors="authenticationValidationList"
        max="9999"
        min="0"
        data-test="authentication-invalid"
      >
        <template slot="label">
          <span
            class="medium-3 cell pega-form-label"
            data-test="authentication-label"
          >認証番号&nbsp;<small>{{ authenticationValidLabel }}</small></span>
        </template>
      </form-item-number>
      <form-item-group
        v-model="permissions"
        :disabled="!isGeneral"
        :options="permissionOptions"
        data-test="permission-form-item-group"
      >
        <template slot="label">
          <span class="medium-3 cell pega-form-label">操作権限&nbsp;<small>(任意)</small></span>
        </template>
      </form-item-group>
      <form-item-group
        v-model="receivableMailTypes"
        :options="receivableMailTypeOptions"
      >
        <template slot="label">
          <span class="medium-3 cell pega-form-label">受信メールの設定&nbsp;<small>(任意)</small></span>
        </template>
      </form-item-group>
      <div class="grid-x grid-padding-y grid-margin-y">
        <div class="cell boss-layout boss-layout-center">
          <button
            :disabled="isDisabled"
            class="boss-button boss-button-confirm pega-button pega-width-auto"
            data-test="submit"
            @click="onRegisterClick"
          >
            <span
              class="boss-button-confirm-text"
              data-test="confirm-button"
            >
              {{ submitLabel }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.certification-number-length {
  width: 5em;
}
</style>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormItem from '@/components/atoms/FormItem'
import FormItemGroup from '@/components/atoms/FormItemGroup'
import FormItemNumber from '@/components/atoms/FormItemNumber'
import { mapGetters } from 'vuex'

export default {
  components: {
    SettingHeader,
    FormItem,
    FormItemGroup,
    FormItemNumber
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      staffName: '',
      tel: '',
      email: '',
      loginId: '',
      authentication: '',
      isGeneral: true,
      permissions: [],
      receivableMailTypes: []
    }
  },
  computed: {
    isOverLengthStaffName () {
      return this.staffName.length > 25
    },
    isOverLengthTel () {
      return this.tel.length > 50
    },
    isOverLengthEmail () {
      return this.email.length > 255
    },
    isLengthValidationAuthentication () {
      return this.authentication.length && this.authentication.length !== 4
    },
    loginIdLabel () {
      return this.loginId ? this.loginId : '※ログインIDは登録後に自動付与されます。'
    },
    ...mapGetters({
      permissionOptions: 'optionalPermissionsMaster',
      receivableMailTypeOptions: 'receivableMailTypesMaster'
    }),
    isDisabled () {
      return !this.staffName ||
      !this.email ||
      this.isLengthValidationAuthentication ||
      (!this.isGeneral && !this.authentication)
    },
    formTypeLabel () {
      return this.id ? '編集' : '登録'
    },
    submitLabel () {
      return this.id ? 'この内容でアカウントを編集する' : 'この内容でアカウントを登録し、ID／仮PWを送信する'
    },
    authenticationValidLabel () {
      return this.isGeneral ? '(任意：4桁)' : '(4桁)'
    },
    authenticationValidationList () {
      return [
        {
          isShow: this.isLengthValidationAuthentication,
          message: '4桁で入力してください'
        }
      ]
    }
  },
  created () {
    this.id && this.fetchStaff()
  },
  methods: {
    onRegisterClick () {
      this.$emit(
        'submit',
        {
          staffName: this.staffName,
          tel: this.tel,
          email: this.email,
          authentication: this.authentication,
          permissionIds: this.permissions,
          receivableMailTypeIds: this.receivableMailTypes
        }
      )
    },
    fetchStaff () {
      this.$http.secured.get(`/account/edit/settings/staff/${this.id}`)
        .then(response => {
          this.$set(this, 'staffName', response.data.staffName)
          this.$set(this, 'tel', response.data.tel)
          this.$set(this, 'email', response.data.email)
          this.$set(this, 'loginId', response.data.loginId)
          this.$set(this, 'authentication', response.data.authentication)
          this.$set(this, 'isGeneral', response.data.isGeneral)
          this.$set(this, 'permissions', response.data.permissions.map(permission => permission.id))
          this.$set(this, 'receivableMailTypes', response.data.receivableMailTypes.map(receivableMailType => receivableMailType.id))
        })
    }
  }
}
</script>
